var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Page',[_c('Container',[_c('div',{staticClass:"pa-a tc-danger"},[_vm._v("请长按以下准考证保存图片，自行打印。")]),_vm._v(" "),(_vm.admitCardUrl)?_c('XImage',{attrs:{"src":_vm.admitCardUrl,"width":"100%"}}):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }